/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetToolMetadataBatchRequestBody,
  SetToolMetadataBatchRequestBody$Outbound,
  SetToolMetadataBatchRequestBody$outboundSchema,
} from "../components/settoolmetadatabatchrequestbody.js";

export type AddMcpServerToolMetadataBatchSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type AddMcpServerToolMetadataBatchSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type AddMcpServerToolMetadataBatchSecurity = {
  option1?: AddMcpServerToolMetadataBatchSecurityOption1 | undefined;
  option2?: AddMcpServerToolMetadataBatchSecurityOption2 | undefined;
};

export type AddMcpServerToolMetadataBatchRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  setToolMetadataBatchRequestBody: SetToolMetadataBatchRequestBody;
};

/** @internal */
export type AddMcpServerToolMetadataBatchSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const AddMcpServerToolMetadataBatchSecurityOption1$outboundSchema:
  z.ZodMiniType<
    AddMcpServerToolMetadataBatchSecurityOption1$Outbound,
    AddMcpServerToolMetadataBatchSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function addMcpServerToolMetadataBatchSecurityOption1ToJSON(
  addMcpServerToolMetadataBatchSecurityOption1:
    AddMcpServerToolMetadataBatchSecurityOption1,
): string {
  return JSON.stringify(
    AddMcpServerToolMetadataBatchSecurityOption1$outboundSchema.parse(
      addMcpServerToolMetadataBatchSecurityOption1,
    ),
  );
}

/** @internal */
export type AddMcpServerToolMetadataBatchSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const AddMcpServerToolMetadataBatchSecurityOption2$outboundSchema:
  z.ZodMiniType<
    AddMcpServerToolMetadataBatchSecurityOption2$Outbound,
    AddMcpServerToolMetadataBatchSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function addMcpServerToolMetadataBatchSecurityOption2ToJSON(
  addMcpServerToolMetadataBatchSecurityOption2:
    AddMcpServerToolMetadataBatchSecurityOption2,
): string {
  return JSON.stringify(
    AddMcpServerToolMetadataBatchSecurityOption2$outboundSchema.parse(
      addMcpServerToolMetadataBatchSecurityOption2,
    ),
  );
}

/** @internal */
export type AddMcpServerToolMetadataBatchSecurity$Outbound = {
  Option1?: AddMcpServerToolMetadataBatchSecurityOption1$Outbound | undefined;
  Option2?: AddMcpServerToolMetadataBatchSecurityOption2$Outbound | undefined;
};

/** @internal */
export const AddMcpServerToolMetadataBatchSecurity$outboundSchema:
  z.ZodMiniType<
    AddMcpServerToolMetadataBatchSecurity$Outbound,
    AddMcpServerToolMetadataBatchSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(
        z.lazy(() =>
          AddMcpServerToolMetadataBatchSecurityOption1$outboundSchema
        ),
      ),
      option2: z.optional(
        z.lazy(() =>
          AddMcpServerToolMetadataBatchSecurityOption2$outboundSchema
        ),
      ),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function addMcpServerToolMetadataBatchSecurityToJSON(
  addMcpServerToolMetadataBatchSecurity: AddMcpServerToolMetadataBatchSecurity,
): string {
  return JSON.stringify(
    AddMcpServerToolMetadataBatchSecurity$outboundSchema.parse(
      addMcpServerToolMetadataBatchSecurity,
    ),
  );
}

/** @internal */
export type AddMcpServerToolMetadataBatchRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SetToolMetadataBatchRequestBody: SetToolMetadataBatchRequestBody$Outbound;
};

/** @internal */
export const AddMcpServerToolMetadataBatchRequest$outboundSchema: z.ZodMiniType<
  AddMcpServerToolMetadataBatchRequest$Outbound,
  AddMcpServerToolMetadataBatchRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    setToolMetadataBatchRequestBody:
      SetToolMetadataBatchRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      setToolMetadataBatchRequestBody: "SetToolMetadataBatchRequestBody",
    });
  }),
);

export function addMcpServerToolMetadataBatchRequestToJSON(
  addMcpServerToolMetadataBatchRequest: AddMcpServerToolMetadataBatchRequest,
): string {
  return JSON.stringify(
    AddMcpServerToolMetadataBatchRequest$outboundSchema.parse(
      addMcpServerToolMetadataBatchRequest,
    ),
  );
}
